import { gql } from '@apollo/client'

export const GET_ACTIVITY_PROCESSES_COUNTERS = gql`
  query GetActivityProcessCountersByRol($filters: countProcessFilterInput) {
    getActivityProcessCountersByRol(filters: $filters) {
      process {
        total
        pending
        completed
        canceled
        averageCompleted
      }
    }
  }
`
